import React from 'react';
import PropTypes from 'prop-types';
import {useTheme, makeStyles} from '@material-ui/core/styles';
import {
    useMediaQuery,
    Grid,
    Typography,
    colors,
    ListItem,
    ListItemAvatar,
    Avatar,
    List,
    Button
} from '@material-ui/core';
import {IconAlternate, SectionHeader} from 'components/molecules';
import {DescriptionListIcon, Section} from 'components/organisms';
import clsx from "clsx"
import {IconImage, Image} from "../../../../components/atoms";

const useStyles = makeStyles((theme) => ({
    fontWeight900: {
        fontWeight: 900,
    },
    noPaddingBottom: {
        paddingBottom: 0,
    },
    noPaddingTop: {
        paddingTop: 0,
    },
    bulletList: {
        marginLeft: theme.spacing(2),
        paddingLeft: theme.spacing(2)
    },
    list: {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            marginBottom: theme.spacing(4),
        },
    },
    sup: {
        color: theme.palette.secondary.main
    }
}));

const theProblems = (classes) => [
    {
        icon: () => <IconAlternate fontIconClass={'fas fa-file-contract'} size="medium" color={colors.indigo}
                                   Component={()=><IconImage
                                      url={'https://s3.amazonaws.com/content.rev-lock.com/images/icons/DeferredRevenue.svg'}/>}/>,
        title: 'Tracking Deferred Revenue properly requires',
        subtitle:
           <ul className={classes.bulletList}>
               <li>Roll-forward your deferred revenue</li>
               <li>Recognize revenue at the lowest level</li>
               <li>Pro-rate recognition</li>
               <li>Lock down closed accounting periods</li>
               <li>Deal with cancellations / modifications</li>
           </ul>
    },
    {
        icon: () => <IconAlternate fontIconClass={'fas fa-file-contract'} size="medium" color={colors.indigo}/>,
        title: 'RevRec gets even more complex when you',
        subtitle:
           <ul className={classes.bulletList}>
               <li>Bundle products or services</li>
               <li>Offer discounts</li>
               <li>Modify contracts</li>
               <li>Offer add-ons</li>
               <li>And more…</li>
           </ul>
    },
    {
        icon: () => <IconAlternate
           fontIconClass={'far fa-file-excel'}
           size="medium"
           color={colors.indigo}/>,
        title: "Spreadsheets can't handle this",
        subtitle:
           <ul className={classes.bulletList}>
               <li>Delays in results</li>
               <li>Errors in results</li>
               <li>Too much resource time</li>
               <li>Lack of meaningful reporting</li>
               <li><b>Frustrated accountants</b></li>
           </ul>
    }
];

const features = [
    "Comply with ASC 606",
    "Get GAAP Revenue Faster",
    "Reduce Errors",
    "Improve Auditability",
    "Get Better Insights into Revenue",
    "Manage Growth"];

const Services = ({className, ...rest}) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    
    const title = (
       <Typography variant="h4" component="span" className={classes.fontWeight900}>
           To grow your SaaS<sup className={classes.sup}>+</sup> business you need to &nbsp;<br/>
           <Typography component="span" variant="h2" style={{fontWeight: 800}} color="primary">Automate Rev
               Rec</Typography>
       </Typography>
    );
    
    const data = theProblems(classes);
    
    return (
       <div className={className} {...rest}>
           <Section narrow className={classes.noPaddingBottom}>
               <SectionHeader
                  title={title}
                  align="center"
                  titleProps={{
                      variant: 'h2',
                      color: 'textPrimary',
                  }}
                  data-aos="fade-up"
               />
           </Section>
           <Section className={clsx(classes.noPaddingTop, classes.noPaddingBottom)}>
               <Grid container spacing={isMd ? 4 : 2} alignContent={'center'}>
                   {data.map((item, index) => {
                       const Icon = item.icon;
                       return (<Grid key={index} item xs={12} sm={4} data-aos={'fade-up'}>
                           <DescriptionListIcon
                              title={item.title}
                              subtitle={item.subtitle}
                              icon={<Icon/>}
                              align="left"
                           />
                       </Grid>)
                   })}
               </Grid>
           </Section>
       </div>
    );
};

Services.propTypes = {
    /**
     * External classes
     */
    className: PropTypes.string,
};

export default Services;
